export interface EstimateParameters {
  defaultOverhead: number;
  defaultMarkup: number;
  lastModifiedById?: string;
  lastModified?: Date;
}

export const estimateParametersChatbotFields = {
  defaultOverhead: {
    type: 'number',
    description: 'Percentage value for default overhead. Should be only set if the intent is to change it.',
  },
  defaultMarkup: {
    type: 'number',
    description: 'Percentage value for default markup. Should be only set if the intent is to change it.',
  },
};
